import { useStateSelector } from './useStateSelector';

export const useCooperativeId = () => {
  const coopId = useStateSelector(
    (state) => state.settings.current_cooperative
  );

  return coopId;
};
